<template>
  <div class="container">
    <div class="bg-ff flex f-jcenter bg-fff pa-t-40 pa-b-40" v-if="!isWeixin">
      <div class="flex f-between width80">
        <div class="t-center stop c-red">
          <i class="iconfont icon-dingdandingdanmingxishouzhimingxi"></i>
          <div class="ma-t-10">第一步 提交订单</div>
        </div>
        <div class="t-center stop flex f-jcenter f-center">
          <i class="iconfont icon-xiayibu c-666"></i>
        </div>
        <div class="t-center stop">
          <i class="iconfont icon-zhangdan"></i>
          <div class="ma-t-10 c-666">第二步 确认支付</div>
        </div>
        <div class="t-center stop flex f-jcenter f-center">
          <i class="iconfont icon-xiayibu c-666"></i>
        </div>
        <div class="t-center stop">
          <i class="iconfont icon-dingdan-yiwancheng"></i>
          <div class="ma-t-10 c-666">第三步 支付成功</div>
        </div>
      </div>
    </div>

    <div class="pa-30 bg-fff ma-t-20">
      <div class="fon-18 font-bold">请填写收货地址：</div>
      <div class="flex f-center ma-t-20 width100">
        <div class="width15 t-right"><span class="c-red">*</span>收货人：</div>
        <div class="width30">
          <el-input
            v-model="formData.Name"
            placeholder="请输收货人"
          ></el-input>
        </div>
      </div>
      <div  class="flex f-center ma-t-20">
        <div class="width15 t-right"><span class="c-red">*</span>联系电话：</div>
        <div class="width30">
          <el-input
            v-model="formData.Phone"
            placeholder="请输入联系电话"
          ></el-input>
        </div>
      </div>
      <div class="flex f-center ma-t-20" v-if="amountData.IsReal">
        <div class="width15 t-right"><span class="c-red">*</span>请填写收货地址：</div>
        <div class="width30">
          <el-input
            v-model="formData.Address"
            placeholder="请输入收货地址"
          ></el-input>
        </div>
      </div>
      <div class="flex f-center ma-t-20">
        <div class="width15 t-right"><span class="c-red">*</span>请填写邮箱地址：</div>
        <div class="width30">
          <el-input
            v-model="formData.Mail"
            placeholder="请输入邮箱地址"
          ></el-input>
        </div>
      </div>
    </div>

    <div class="bg-fff ma-t-20 f-wrap pa-30">
        <div class="fon-18 font-bold">确认订单信息：</div>
        <div class="flex ma-t-20">
          <div class="width15 t-right">回报档：</div>
          <div>
            <div>{{ amountData.Name }} （ <span class="c-red">￥{{ amountData.MinAmount  }} ~ {{ amountData.MaxAmount  }}</span> ） </div>
            <div class="c-yellow fon-14">
              *该产品为定制产品，众筹成功后不支持无理由退货退款
            </div>
          </div>
        </div>

        <div class="flex f-center ma-t-20">
          <div class="width15 t-right"><span class="c-red">*</span> 支持金额：</div>
          <div class="width30">
            <el-input
              v-model="formData.Amount"
              
              type="number"
            ></el-input>
          </div>
        </div>

        <div class="flex ma-t-20">
          <div class="width15 t-right">支持回报：</div>
          <div>{{ amountData.Summary }}</div>
        </div>
        <div class="flex ma-t-20">
          <div class="width15 t-right">留言信息：</div>
          <div class="width50">
            <el-input
              v-model="formData.Remark"
              placeholder="请输入留言"
              
              type="textarea"
              :rows="5"
            ></el-input>
          </div>
        </div>
    </div>

    <el-row type="flex" class="f-wrap bg-fff ma-t-20 pa-30">
      <el-col :xs="24" :sm="3" class="fon-18 font-bold">免责协议：</el-col>
      <el-col :xs="24" :sm="20" class="c-666">
        1.点击“提交订单”，即表明您已阅读并同意 《支持者协议》 及《隐私权政策》，并自愿承担众筹相应风险。<br><br>
        2.您参与众筹是支持将创意变为现实的过程，而不是直接的商品交易，因此存在一定风险。请您根据自己的判断选择、支持众筹项目。众筹存在于发起人与支持者之间，短片周网作为第三方平台，只提供网络空间、技术支持等服务。众筹的回报产品和承诺由发起人提供和作出，发起者和支持者应依法承担使用短片周产品产生的法律后果。<br><br>
        3.众筹项目的回报发放及其他后续服务事项均由发起人负责。如果发生发起人无法发放回报、延迟发放回报、不提供回报后续服务等情形，您需要直接和发起人协商解决。<br><br>
        4.由于发起人能力和经验不足、市场风险、法律风险等各种因素，众筹可能失败。对于在众筹期限届满前失败的项目，您支持项目的款项会全部原路退还给您；对于众筹成功的项目，支持者不能通过短片周平台申请退款，若此时支持者因任何原因希望退款，需直接与发起者协商，若发 起者同意退款，需直接向支持者退回款项，短片周不会从可结算款项中扣除该部分退款金额。您对项目发起人的无偿支持以及额外打赏，一旦众筹成功将不予退款，但众筹失败的情况除外。<br>
      </el-col>
    </el-row>

    <div class="pa-30 bg-fff ma-t-20 ma-b-30 t-center">
      <div class="btn-support" @click="btnAddOrder()">提 交</div>
      <!-- <span class="c-666 ma-l-20">请在提交后10分钟内支付，过期将失效</span> -->
    </div>
  </div>
</template>

<script>
  import {
    postCrowdFundingAdd,
    getCrowdFundingDetail,
    getMember,
    // orderPay
  } from '../../api.js'
  export default {
    data() {
      return {
        amountData: {},
        projectData: {},
        amountId: '',
        projectId: '',

        formData: {
          Id: 0,
          Name:'',//收货人
          Phone: '',
          Address:'',//收货地址
          Mail:'',//邮箱地址
          SettingId: 0,
          Amount:0,//支持金额
          Remark: '',
        },
        projectName: '', //项目名称
        isWeixin: false
      }
    },
    activated() {
      if (
        this.$route.query.amountId != this.amountId ||
        this.$route.query.projectId != this.projectId
      ) {
        this.amountId = this.$route.query.amountId
        this.projectId = this.$route.query.projectId
        this.formData.Id = this.$route.query.projectId
        this.formData.SettingId = this.$route.query.amountId
        //判断是否在微信浏览器里，如果在微信支付时使用微信支付，否则使用扫码支付
        var ua = navigator.userAgent.toLowerCase()
        this.isWeixin = ua.indexOf('micromessenger') != -1
        this.loadData()

        if(localStorage.getItem('shippingAddress')){
          this.formData.Address=localStorage.getItem('shippingAddress')
        }

        getMember().then((res) => {
          this.formData.Phone = res.data.Data.Phone
        })
      }
    },
    beforeRouteEnter(to, from, next) {
      window.scroll(0, 0)

      next()
    },
    methods: {
      //获取众筹信息
      loadData() {
        getCrowdFundingDetail({ id: this.projectId }).then((res) => {
          this.projectData = res.data.Data
          this.amountData = this.projectData.SettingList.find((item) => {
            if (item.Id == this.amountId) {
              return item
            }
          })
        })
      },
      //下单
      btnAddOrder() {
        let token = localStorage.getItem('AccessToken')
        if (!token) {
          this.$alert('您还未登录请先登录', '提示', {
            confirmButtonText: '去登录',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              this.$router.push('/login')
            })
            .catch(() => {})
          return
        }

        //数据验证
        if (!this.formData.Name) {
          this.$message({
            message: '请填写收货人',
            type: 'warning'
          })
          return
        }
        if (!this.formData.Phone) {
          this.$message({
            message: '请填写手机号',
            type: 'warning'
          })
          return
        }
        if (!this.formData.Address && this.amountData.IsReal) {
          this.$message({
            message: '请填写收货地址',
            type: 'warning'
          })
          return
        }
        if (!this.formData.Mail) {
          this.$message({
            message: '请填写邮箱地址',
            type: 'warning'
          })
          return
        }
        if (!this.formData.Amount) {
          this.$message({
            message: '请填写支持金额',
            type: 'warning'
          })
          return
        }
        if (!/^1\d{10}$/.test(this.formData.Phone)) {
          this.$message({
            message: '手机号格式错误',
            type: 'warning'
          })
          return
        }

        console.log(this.formData)
        postCrowdFundingAdd(this.formData).then((res) => {
          console.log(res.data.Data)

          if(this.formData.Address){
            //存储收货地址
            localStorage.setItem('shippingAddress',this.formData.Address)
          }
          

          this.$router.replace({
              path: '/crowd/support-2',
              query: {
                Key: res.data.Data.Key,
                projectId: this.projectId,
                amountId: this.amountId
              }
            })

        })
      }
    },
    computed: {
    },
    watch:{
      '$route.query.amountId'(val){
        if(val){
          this.amountId = this.$route.query.amountId
          this.projectId = this.$route.query.projectId
          this.loadData()
        }
      },
      '$route.query.projectId'(val){
        if(val){
          this.amountId = this.$route.query.amountId
          this.projectId = this.$route.query.projectId
          this.loadData()
        }
      }
    }
  }
</script>

<style  lang="scss" scoped>
  .width15{
    width: 15%;
  }
  .b-l-1-ee {
    border-left: 1px solid #eee;
  }
  .stop {
    .iconfont {
      font-size: 50px;
    }
  }
  .c-yellow {
    color: #f8ab6b;
  }
  .btn-support {
    padding: 10px 70px;
    background: #fb004d;
    display: inline-block;
    color: #fff;
    cursor: pointer;
  }
  .l-h-30 {
    line-height: 30px;
  }

  
</style>